import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { GardienBadge } from "@/components/GardienBadge";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setAdmin } = useApp();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdmin(data);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-accent/30" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-card rounded-3xl border border-border/50 p-10 shadow-[0_20px_60px_rgb(0,0,0,0.06)]">
        <p className="text-sm uppercase tracking-[0.3em] text-primary">Espace professionnel</p>
        <h1 className="font-serif-display text-4xl mt-3 font-light">Connexion</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="text-sm text-foreground/70 mb-2 block">Email</label>
            <input type="email" required data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-muted/50 border border-border rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary/50 outline-none" />
          </div>
          <div>
            <label className="text-sm text-foreground/70 mb-2 block">Mot de passe</label>
            <input type="password" required data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-muted/50 border border-border rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary/50 outline-none" />
          </div>
          {error && <p className="text-destructive text-sm" data-testid="admin-error">{error}</p>}
          <button disabled={loading} data-testid="admin-login-btn" className="w-full rounded-full bg-primary text-primary-foreground py-4 flex items-center justify-center gap-2 hover:scale-[1.02] transition-transform duration-300 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Se connecter
          </button>
        </form>
        <div className="mt-8 pt-6 border-t border-border/50">
          <GardienBadge gardienId="adele" label="Gardienne de cet espace" />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
